import BaseResource from './BaseResource'

export default class Places extends BaseResource {
  static endpoint = '/api/v1/places' ///profile
}
